// extracted by mini-css-extract-plugin
export default {"campoData":"InputDataCombo_campoData__v2SFw"};